import utility from './utility'

const checkout = {
    init: function () {
        var checkoutForm = document.querySelector("#checkout--checkout-form");
        if (checkoutForm) {
            new this.checkoutActions(checkoutForm);
        }
        this.checkoutExpandClick();
    },

    checkoutActions: class {
        constructor(checkoutForm) {
            this.checkoutForm = checkoutForm;
            this.showJackpotWarning = false;
            this.checkDuplicateNumbers = false;
            this.checkBraintreeHostedFields = false;
            this.checkBraintreeHostedFormValid = false;
            this.checkCvvOnlyHostedFields = false;

            if (checkoutForm.querySelector("input[name=SavePayPal]")) {
                this.savePayPal = checkoutForm.querySelector("input[name=SavePayPal]").checked;
            } else {
                this.savePayPal = true
            }
            this.submitButtons = [...checkoutForm.querySelectorAll("button[type=submit]")];
            this.paymentMethods = [...document.querySelectorAll("#account-payment-methods .payment-methods")];
            if (this.paymentMethods) {
                utility.removeFormInputErrors(this.checkoutForm);
            }
            this.activePaymentMethod = "";
            this.paymentMethods.map(paymentMethod => {
                paymentMethod.onclick = (el) => {
                    if (!el.currentTarget.classList.contains('active')) {
                        this.paymentMethods.map(pm => utility.removeClass(pm, "active")) && utility.addClass(el.currentTarget, "active");
                        this.activePaymentMethod = el.currentTarget;
                        this.handlePaymentMethodChange(el.currentTarget);
                        this.refreshPaymentAmount()
                    }
                }
            });

            const continueButton = document.getElementById("checkout-continue");
            if (continueButton) {
                continueButton.onclick = () => utility.showLoginPopup("CHK");
            }

            checkoutForm.onsubmit = () => {
                this.checkDuplicateNumbers = true;
                this.disableSubmitButtons();
                if (!this.activePaymentMethod.dataset || (this.activePaymentMethod.dataset && this.activePaymentMethod.dataset.methodname != 'Credit Card')) {
                    // dont use default checkout function when its a hosted field new credit card 
                    this.beginCheckout();
                }
                return false;
            };

            checkoutForm.onkeypress = (e) => {
                var key = e.charCode || e.keyCode || 0;
                if (key === 13) {
                    e.preventDefault();
                }
            };

            // enable jackpot warning
            if (checkoutForm.dataset.showjackpotwarning === "1" && document.getElementById("checkout--jackpot-warning-popup")) {
                this.showJackpotWarning = true;
            }

            // submit/cancel buttons for jackpot warning
            const jackpotWarningCancelButton = document.getElementById("checkout--jackpot-warning-close");
            if (jackpotWarningCancelButton) {
                jackpotWarningCancelButton.onclick = () => {
                    this.enableSubmitButtons();
                    utility.hidePopups();
                };
            }
            const jackpotWarningSubmitButton = document.getElementById("checkout--jackpot-warning-continue");
            if (jackpotWarningSubmitButton) {
                jackpotWarningSubmitButton.onclick = (ev) => {
                    utility.disableButton(ev.currentTarget);
                    this.beginCheckout();
                };
            }

            // submit/cancel buttons for duplicate numbers check
            const duplicateNumbersCancelButton = document.getElementById("checkout--duplicate-numbers-warning-close");
            if (duplicateNumbersCancelButton) {
                duplicateNumbersCancelButton.onclick = () => {
                    this.enableSubmitButtons();
                    utility.hidePopups();
                };
            }
            const duplicateNumbersSubmitButton = document.getElementById("checkout--duplicate-numbers-warning-continue");
            if (duplicateNumbersSubmitButton) {
                duplicateNumbersSubmitButton.onclick = (ev) => {
                    utility.disableButton(ev.currentTarget);
                    this.beginCheckout();
                };
            }

            // Recreate PayPal button is 'Save Paypal' button is changed
            const payPalSaveCheck = checkoutForm.querySelector("input[name=SavePayPal]");            
            
            if (payPalSaveCheck) {
                payPalSaveCheck.onchange = (el) => {
                    this.savePayPal = el.currentTarget.checked;
                    el.currentTarget.setAttribute("disabled", "disabled");
                    utility.addClass(document.getElementById("checkSavePayPal"), "disabled");
                    this.handlePayPal('paypal');
                }
            }
            window.addEventListener("message", this.handleHostedPaymentMessage.bind(this));
        }

        disableSubmitButtons() {
            this.submitButtons.map(b => utility.disableButton(b));
        }

        enableSubmitButtons() {
            this.submitButtons.map(b => utility.enableButton(b));
        }

        disablePaymentMethods() {
            this.paymentMethods.map(b => utility.addClass(b, "disabled"));
            utility.showNotificationPopup({
                title: "Processing PayPal",
                centreContent: true,
                hideCloseIcon: true,
                content: `Please wait...`
            });
            
        }
        enablePaymentMethods() {
            this.paymentMethods.map(b => utility.removeClass(b, "disabled"));
        }
        handlePaymentMethodChange(paymentOption) {
            if (paymentOption.dataset.paymentmethod === "1001" && !paymentOption.classList.contains('saved')) {
                // New credit card - ignore saved CC
                if (!this.checkBraintreeHostedFields) {
                    this.handlePayPal('hosted')
                }            
            }
           if (paymentOption.dataset.paymentmethod === "4001" && !paymentOption.classList.contains('saved')) {
                //dont re create paypal buttons if saved paypal method is clicked
                this.handlePayPal('paypal')
            }            
        }

        refreshPaymentAmount() {
            const paymentOption = this.activePaymentMethod;
            const ajaxSuccess = (e) => {
                var data = JSON.parse(e.target.responseText);
                const paymentPaymentContainer = document.querySelector(".checkout-payment-container");
                const paymentDetails = `
                        <p>Available Funds <span>${data.AccountBalance}</span></p>
                        <p>Payable <span id="checkout-payment-payable">${data.PaymentAmount}</span>
                        ${data.MinPaymentAmountApplied === "1" ? `<span id="checkout-payment-mindeposit"> (Min deposit <span id="checkout-payment-mindeposit-amount">${data.MinPaymentAmount}</span>)</span>`:``}
                        </p>
                        <p>Remaining balance <span id="checkout-payment-remaining-balance">${data.RemainingBalance}</span></p>
                        `
                        paymentPaymentContainer.innerHTML = paymentDetails;
                        utility.addClass(paymentPaymentContainer, "added");

                        if (paymentOption.querySelector(".checkout-payment-payable-button")) {
                            paymentOption.querySelector(".checkout-payment-payable-button").innerHTML = `&nbsp;${data.PaymentAmount}`;
                        }
                        this.checkoutForm.querySelector("input[name='PaymentAmount']").value = data.PaymentAmountRaw;
            };
            const ajaxAlways = () => {
                this.enableSubmitButtons();

                //make an exception to disable PP Hosted Fields submit button if form invalid
                if (!this.checkBraintreeHostedFormValid) {
                    document.getElementById('submit-1001').setAttribute("disabled", "disabled");
                }  
            };
            const ajaxOptions = {
                url: "/api/web/checkout/get-checkout-payment-amount",
                method: "POST",
                data: `paymentMethodId=${paymentOption.dataset.paymentmethod}`,
                success: ajaxSuccess,
                always: ajaxAlways
            };
            this.disableSubmitButtons();
            utility.ajaxRequest(ajaxOptions);
        }

        beginCheckout() {
            if (this.checkDuplicateNumbers) {
                this.checkDuplicateNumbers = false;
                this.performDuplicateNumbersCheck();
                return;
            }
            if (this.showJackpotWarning) {
                this.showJackpotWarning = false;
                this.showJackpotWarningPopup();
                return;
            }
            let paymentMethodId = 0;
            let paymentMethod = "";
            let customerPaymentMethodId = 0;
            let showDepositConfirm = false;
            const paymentOption = this.activePaymentMethod;
            if (paymentOption) {
                paymentMethod = paymentOption.dataset.methodname;
                paymentMethodId = paymentOption.dataset.paymentmethod;
                customerPaymentMethodId = paymentOption.dataset.customerpaymentid;
                showDepositConfirm = paymentOption.dataset.showconfirm === "1";
            }
            this.checkoutForm.querySelector("input[name=PaymentMethodId]").value = paymentMethodId;
            this.checkoutForm.querySelector("input[name=CustomerPaymentMethodId]").value = customerPaymentMethodId;
            
            if (showDepositConfirm) {
                const paymentAmount = this.checkoutForm.querySelector("input[name='PaymentAmount']").value;
                this.validateDeposit(paymentMethod, paymentAmount);
            }
            else {
                if (paymentMethod == 'PayPal') {
                    this.handlePayPal('paypal-checkout')
                }
                else {
                    // legacy CC - striaght chekcout
                    //dont do default if PayPal hosted field
                    // default use of balance
                    this.performCheckout();
                }
            }
        }

        performDuplicateNumbersCheck() {
            const ajaxSuccess = (e) => {
                var result = JSON.parse(e.target.responseText);
                if (result.hasDuplicateGames) {
                    // loop thru game ids and mark them as duplicate on the DOM
                    // Take the dupe games + game number innerhtml and embed to popup warning
                    let dupeHtml = "";
                    document.getElementById("popup-duplicate-games").innerHTML = "";
                    for (var lotteryArr of result.duplicateGames) {
                        for (var gameId of lotteryArr.GameIds) {                        
                            let dupeGame = document.getElementById("game-id-" + gameId)
                            let gameNumber = dupeGame.previousElementSibling.querySelector(".game-count");
                            dupeHtml += `<div class="game-number blue">${lotteryArr.Lottery} - ${gameNumber.innerHTML}</div>
                                        <div class="dupe-list">${dupeGame.querySelector('.lottery-numbers-container').innerHTML}</div>`;

                            if (!dupeGame.previousElementSibling.classList.contains('has-duplicate')) {
                                gameNumber.innerHTML += " (Duplicate Game)";                           
                            }
                            utility.addClass(dupeGame, 'has-duplicate');
                            utility.addClass(dupeGame.previousElementSibling, 'has-duplicate');
                        }

                        if (lotteryArr.CartDuplicate && lotteryArr.AccountDuplicate) {
                            document.getElementById("popup-duplicate-games-msg").innerHTML = `You have the same game/s in your cart more than once and you have already purchased one or more of the games in your cart.`;
                        }
                        else if (lotteryArr.CartDuplicate) {
                            document.getElementById("popup-duplicate-games-msg").innerHTML = `You have the same game/s in your cart more than once.`;
                        }
                        else if (lotteryArr.AccountDuplicate) {
                            document.getElementById("popup-duplicate-games-msg").innerHTML = `You have already purchased one or more of the games in your cart.`;
                        }
                    }
                    
                    document.getElementById("popup-duplicate-games").innerHTML += dupeHtml;
                    this.showDuplicateNumbersPopup();
                }
                else {
                    this.beginCheckout();
                }
            };
            const ajaxOptions = {
                url: "/api/web/checkout/review",
                method: "POST",
                success: ajaxSuccess
            };
            utility.ajaxRequest(ajaxOptions);
        }

        showDuplicateNumbersPopup() {
            utility.enableButton(document.getElementById("checkout--duplicate-numbers-warning-continue"));
            utility.showPopup(document.getElementById("checkout--duplicate-numbers-warning-popup"));
        }

        showJackpotWarningPopup() {
            utility.enableButton(document.getElementById("checkout--jackpot-warning-continue"));
            utility.showPopup(document.getElementById("checkout--jackpot-warning-popup"));
        }

        validateDeposit(paymentMethod, paymentAmount, deviceData, nonce) {
            let formData = utility.getFormData(this.checkoutForm);
            let hostingRequired = this.activePaymentMethod.dataset.hostingrequired ? this.activePaymentMethod.dataset.hostingrequired : 0;
          

            if (deviceData) {
                formData += `&BTRDeviceData=${deviceData}`
            }
            if (nonce) {
                formData += `&BTRPaymentNonce=${encodeURIComponent(nonce)}`
            }
            const ajaxSuccess = (e) => {
                utility.removeFormInputErrors(this.checkoutForm);
                var result = JSON.parse(e.target.responseText);
                if (result.result === "S") {
                    document.getElementById("global--deposit-confirmation-popup-method").innerHTML = paymentMethod;
                    document.getElementById("global--deposit-confirmation-popup-amount").innerHTML = Number(paymentAmount).toFixed(2);
                    document.getElementById("global--deposit-confirmation-popup-button").onclick = (ev) => {
                        utility.disableButton(ev.currentTarget);
                        if (paymentMethod == 'PayPal') {
                            // Handle PayPal Tokenized Payment
                            this.handlePayPal('paypal-checkout')
                        }
                        else if (paymentMethod == 'Credit Card') {
                            this.performPayPalCheckout(deviceData, nonce)
                        }
                        else if ((paymentMethod == 'Visa' || paymentMethod == 'Mastercard') && hostingRequired ==1) {
                            //saved credit card
                            this.handlePayPal('hosted-checkout')
                        }
                        else {
                            this.performCheckout();
                        }
                    };
                    document.getElementById("global--deposit-cancel-popup-button").onclick = (ev) => {
                        this.enableSubmitButtons();
                        utility.hidePopups();
                    };
                    utility.enableButton(document.getElementById("global--deposit-confirmation-popup-button"));
                    utility.showPopup(document.getElementById("global--deposit-confirmation-popup"));
                }
                else if (result.result === "E") {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: result.message
                    });
                }
                else if (result.result === "F") {
                    this.enableSubmitButtons();
                    utility.hidePopups();
                    result.fieldErrors.map(error => {
                        utility.addFormInputError(this.checkoutForm, error.Name, error.Error);
                    });
                }
                else {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: "An unknown error has occurred"
                    });
                }
            };
            const ajaxError = () => {
                utility.removeFormInputErrors(this.checkoutForm);
            };
            const ajaxAlways = () => {
                this.enableSubmitButtons();
                utility.removeClass(this.activePaymentMethod, "disabled");
                this.enablePaymentMethods();
            };
            const ajaxOptions = {
                url: "/api/web/account/validate-deposit",
                method: "POST",
                data: formData,
                success: ajaxSuccess,
                error: ajaxError,
                always: ajaxAlways
            };
            this.disableSubmitButtons();
            utility.ajaxRequest(ajaxOptions);
        }

        performCheckout() {
            const ajaxSuccess = (e) => {
                utility.removeFormInputErrors(this.checkoutForm);
                this.handleCheckoutCompleteResponse(JSON.parse(e.target.responseText));
            };
            const ajaxAlways = () => {
                this.enableSubmitButtons();

                //clear paypal disable
                this.enablePaymentMethods();
            };
            const ajaxOptions = {
                url: "/api/web/checkout/perform-checkout",
                method: "POST",
                data: utility.getFormData(this.checkoutForm),
                success: ajaxSuccess,
                always: ajaxAlways
            };
            utility.ajaxRequest(ajaxOptions);
        }

        handleHostedPaymentMessage(event) {
            if (!event || !event.data) {
                return;
            }
            if (event.type !== "message") {
                return;
            }
            if (event.data.eventAction !== "PUR") {
                return;
            }
            if (event.origin !== window.location.origin) {
                return;
            }
            if (!event.data.paymentRef || !this.paymentTransactionRef || event.data.paymentRef !== this.paymentTransactionRef) {
                return;
            }
            if (event.data.paymentMethodId === 7001) {
                this.completePaysafecardDeposit(event);
            }
        }

        beginPaysafecardDeposit(authURL) {
            const ajaxOptions = {
                url: "/api/web/account/deposit-hosted-payment",
                method: "POST",
                data: "paymentUrl=" + encodeURIComponent(authURL) + "&paymentMethodId=7001",
                success: (e) => utility.showHostedPaymentPopup(e.target.responseText),
                error: () => this.enableSubmitButtons()
            };
            utility.ajaxRequest(ajaxOptions);
        }

        completePaysafecardDeposit(event) {
            utility.setHostedPaymentPopupComplete();
            const ajaxSuccess = (e) => {
                this.handleCheckoutCompleteResponse(JSON.parse(e.target.responseText));
            };
            const ajaxError = () => {
                if (event.data.eventType === "cancel") {
                    utility.hidePopups();
                }
                else {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: "We are waiting for a response from paysafecard. The transaction may or may not go through. It might take up to 15 minutes to get a result from them. We will email you as soon as we can."
                    });
                }
            };
            const ajaxOptions = {
                url: "/api/web/account/perform-checkout-psc?paymentReferenceNo=" + event.data.paymentRef,
                method: "POST",
                data: utility.getFormData(this.checkoutForm),
                success: ajaxSuccess,
                error: ajaxError,
                always: () => this.enableSubmitButtons()
            };
            utility.ajaxRequest(ajaxOptions);
        }

        handleCheckoutCompleteResponse(result) {
            if (result.result === "R") {
                window.location.href = result.location;
            }
            else if (result.result === "E") {
                utility.showNotificationPopup({
                    title: "Error",
                    content: result.message
                });
            }
            else if (result.result === "I") {
                let message = "";
                for (let i = 0; i < result.messages.length; i++) {
                    message += result.messages[i] + "<br/><br/>";
                }
                utility.showNotificationPopup({
                    title: "Error",
                    content: message,
                    hideCloseIcon: true,
                    button: {
                        url: window.location.href
                    }
                });
            }
            else if (result.result === "F") {
                utility.hidePopups();
                result.fieldErrors.map(error => {
                    var input = this.checkoutForm.querySelector("[name=" + error.Name + "]");
                    if (input) {
                        if (input.tagName === "SELECT") {
                            input.nextSibling.classList.add("has-error");
                        }
                        else {
                            input.parentNode.classList.add("has-error");
                        }
                        var errorNode = input.parentNode.querySelector(".input-error");
                        if (errorNode) {
                            errorNode.style.display = null;
                            errorNode.textContent = error.Error;
                        }
                    }
                });
            }
            else if (result.result === "PP" && result.paysafecardAuthURL) {
                this.paymentTransactionRef = result.paymentRef;
                this.beginPaysafecardDeposit(result.paysafecardAuthURL);
            }
            else if (result.result === "PU") {
                utility.showNotificationPopup({
                    title: "Pending",
                    content: result.message
                });
            }
            else if (result.result === "C") {
                utility.showNotificationPopup({
                    title: "Cancelled",
                    content: result.message
                });
            }
            else {
                utility.showNotificationPopup({
                    title: "Error",
                    content: "An unknown error has occurred"
                });
            }

            //clear disabled forms
            if (result.result !== "R") {
                this.enablePaymentMethods();
            }
        }


        /** PayPal Hosted Fields Credit Card*/

        createHostedFields(deviceData, clientInstance) {
            let that = this;
            that.enableSubmitButtons();
            let form = document.getElementById('checkout--checkout-form');
            let submit = document.getElementById('submit-1001');
            let loader = document.getElementById('bt-loader');            
            let formloader = document.getElementById('bt-form');            
            submit.setAttribute("disabled", "disabled");

            braintree.hostedFields.create({
                preventAutofill: false,
                client: clientInstance,
                styles: {
                    input: {
                        'input': 'hosted-fields',
                        'font-size': '1rem',
                        color: '#2C68A5'
                    },
                    'input.invalid': {
                        'color': 'red'
                    },     
                },
                fields: {
                    number: {
                        supportedCardBrands: {
                            visa: true,
                            'master-card': true
                        },
                        container: '#card-number',
                        placeholder: 'Enter your card number'
                    },
                    cardholderName: {
                        selector: '#card-name',
                        placeholder: 'Name as it appears on your card'
                    },
                    cvv: {
                        container: '#cvv',
                        placeholder: 'Enter valid 3-digit CVV'
                    },
                    expirationDate: {
                        container: '#expiration-date',
                        placeholder: 'MM/YYYY'
                    }
                }
            }, function (hostedFieldsErr, hostedFieldsInstance) {
                if (hostedFieldsErr) {
                    let error = `There was an error when trying to add a new card.<br/>Please try again.`;
                    utility.logError("HF New Card Checkout: Error creating client", hostedFieldsErr, function () {
                        that.handlePayPalError(error);
                    });
                    return;
                }

                //hide loader, show form
                if (loader) {
                    loader.style.display = 'none';
                }
                if (formloader) {
                    utility.removeClass(formloader, "disabled");
                }


                 // Set auto focus on card number
                hostedFieldsInstance.focus('number', function (focusErr) {
                    if (focusErr) {
                        console.error(focusErr);
                    }
                });

                //validate on blur
                hostedFieldsInstance.on('blur', function (event) {
                    var field = event.fields[event.emittedBy];
                    var container = field.container;
                    var label = container.nextElementSibling;

                    if (field.isEmpty) {
                        utility.addClass(label, "show");
                        utility.addClass(container, "is-invalid");
                    }               
                    else {
                        utility.removeClass(label, "show");
                        utility.removeClass(container, "is-invalid");

                    }
                });

                // check validity and enable submit
                hostedFieldsInstance.on('validityChange', function (event) {
                    var allValid = true;
                    var key;

                    for (key in event.fields) {
                        utility.removeClass(event.fields[key].container, "is-invalid");
                        var label = event.fields[key].container.nextElementSibling;
                        if (label) {
                            utility.removeClass(label, "show");
                        }

                        if (event.fields[key].isValid === false) {
                            utility.addClass(event.fields[key].container, "is-invalid");
                            if (label) {
                                utility.addClass(label, "show");
                            }
                            allValid = false;
                            break;
                        }

                    }

                    if (allValid) {
                        submit.removeAttribute('disabled');
                        that.checkBraintreeHostedFormValid = true;
                    } else {
                        submit.setAttribute("disabled", "disabled");
                        that.checkBraintreeHostedFormValid = false;
                    }
                });

                // check for unsupported card types - UI update to inform user TODO
                //hostedFieldsInstance.on('cardTypeChange', function (event) {
                //    if (event.cards.length === 1) {
                //        var card = event.cards[0];
                //    } else {
                //        // reset to defaults
                //    }
                //});               

                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    var state = hostedFieldsInstance.getState();
                    var formValid = Object.keys(state.fields).every(function (key) {
                        return state.fields[key].isValid;
                    });

                    if (formValid) {// Tokenize Hosted Fields
                        hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
                            if (tokenizeErr) {
                                let error = `There was an error when submitting your card.<br/>Please try again.`;
                                utility.logError("HF New Card Checkout: createHostedFields Tokenize Error", tokenizeErr, function () {
                                    that.handlePayPalError(error);
                                });
                                return;
                            }

                            const paymentOption = that.activePaymentMethod.dataset.methodname;
                            const paymentAmount = that.checkoutForm.querySelector("input[name='PaymentAmount']").value;
                            const paymentMethodId = that.activePaymentMethod.dataset.paymentmethod;
                            const customerPaymentMethodId = that.activePaymentMethod.dataset.customerpaymentid;
  
                            that.checkoutForm.querySelector("input[name=PaymentMethodId]").value = paymentMethodId;
                            that.checkoutForm.querySelector("input[name=CustomerPaymentMethodId]").value = customerPaymentMethodId;
                            that.validateDeposit(paymentOption, paymentAmount, deviceData, payload.nonce);
                        });
                    } else {
                        // Let the customer know their fields are invalid
                        utility.disableButton(submit);
                    }
                }, false);
                that.checkBraintreeHostedFields = true;
            });
        }

        createCVVOnlyHostedFields(deviceData, clientInstance) {
            let cvvPopup = document.getElementById('deposit--hosted-cvv-popup');
            utility.showPopup(cvvPopup);

            let that = this;
            that.enableSubmitButtons();
            let form = document.getElementById('paypal-hosted-cvv');
            let submit = document.getElementById('submit-hosted-cvv');
            let cancel = document.getElementById('cancel-hosted-cvv');
            let cvvonly = true;
            submit.setAttribute("disabled", "disabled");
            if (!that.checkCvvOnlyHostedFields) {
                braintree.hostedFields.create({
                    preventAutofill: false,
                    client: clientInstance,
                    styles: {
                        input: {
                            'input': 'hosted-fields',
                            'font-size': '1rem',
                            color: '#2C68A5'
                        },
                        'input.invalid': {
                            'color': 'red'
                        },
                    },
                    fields: {
                        cvv: {
                            maxlength: 3,
                            container: '.hosted-cvv-only',
                            placeholder: 'Enter valid 3-digit CVV'
                        }
                    }
                }, function (hostedFieldsErr, hostedFieldsInstance) {
                    if (hostedFieldsErr) {
                        let error = `There was an error when trying to add a new card.<br/>Please try again.`;
                        utility.logError("HF Checkout Update CVV Only: Error creating client", hostedFieldsErr, function () {
                            that.handlePayPalError(error);
                        });
                        return;
                    }

                    // Set auto focus on card number
                    hostedFieldsInstance.focus('cvv', function (focusErr) {
                        if (focusErr) {
                            console.error(focusErr);
                        }
                    });

                    hostedFieldsInstance.on('blur', function (event) {
                        var field = event.fields[event.emittedBy];
                        var container = field.container;
                        var label = container.nextElementSibling;

                        if (field.isEmpty) {
                            utility.addClass(label, "show");
                            utility.addClass(container, "is-invalid");
                        }
                        else {
                            utility.removeClass(label, "show");
                            utility.removeClass(container, "is-invalid");

                        }
                    });

                    // check validity and enable submit
                    hostedFieldsInstance.on('validityChange', function (event) {
                        var allValid = true;
                        var key;

                        for (key in event.fields) {
                            utility.removeClass(event.fields[key].container, "is-invalid");
                            var label = event.fields[key].container.nextElementSibling;
                            if (label) {
                                utility.removeClass(label, "show");
                            }

                            if (event.fields[key].isValid === false) {
                                utility.addClass(event.fields[key].container, "is-invalid");
                                if (label) {
                                    utility.addClass(label, "show");
                                }
                                allValid = false;
                                break;
                            }
                        }

                        if (allValid) {
                            submit.removeAttribute('disabled');
                        } else {
                            submit.setAttribute("disabled", "disabled");
                        }
                    });

                    form.addEventListener('submit', function (event) {
                        event.preventDefault();
                        var state = hostedFieldsInstance.getState();
                        var formValid = Object.keys(state.fields).every(function (key) {
                            return state.fields[key].isValid;
                        });

                        if (formValid) {// Tokenize Hosted Fields
                            if (submit) {
                                utility.disableButton(submit);
                            }
                            hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
                                if (tokenizeErr) {
                                    let error = `There was an error when submitting your card.<br/>Please try again.`;
                                    utility.logError("HF Checkout Submit CVV Only: tokenizeErr", tokenizeErr, function () {
                                        that.handlePayPalError(error);
                                    });
                                    return;
                                }
                                hostedFieldsInstance.clear('cvv');
                                hostedFieldsInstance.focus('cvv');
                                utility.hidePopups();

                                that.performPayPalCheckout(deviceData, payload.nonce, cvvonly)

                            });
                        } else {
                            // Let the customer know their fields are invalid
                            utility.disableButton(submit);
                        }
                    }, false);

                    // Cancel CVV Popup
                    cancel.addEventListener('click', function () {
                        hostedFieldsInstance.clear('cvv');
                        hostedFieldsInstance.focus('cvv');
                        utility.hidePopups();
                    });

                    that.checkCvvOnlyHostedFields = true;
                });
            }
        }


        /** PayPal Buttons */
        handlePayPalError(error) {
            if (!error) {
                error = `<p>Something went wrong.</p><p>Please contact Customer Support.</p>`
            }
            utility.showNotificationPopup(
                {
                    title: "Error", content: error, hideCloseIcon: true,
                    centreContent: true,
                    button: {
                        text: "OK",
                        url: "/checkout/"
                    }
                }
            );

        }

        performPayPalCheckout(deviceData, nonce, isCvvNonce) {
            let formData = utility.getFormData(this.checkoutForm);
            if (deviceData) {
                formData += `&BTRDeviceData=${deviceData}`
            }
  
            if (nonce) {
                if (isCvvNonce) {
                    formData += `&BTRCvvNonce=${encodeURIComponent(nonce)}`
                } else {
                    formData += `&BTRPaymentNonce=${encodeURIComponent(nonce)}`
                }
            }
            const ajaxSuccess = (e) => {
                utility.removeFormInputErrors(this.checkoutForm);
              //  utility.removeClass(this.activePaymentMethod, "disabled")
                this.handleCheckoutCompleteResponse(JSON.parse(e.target.responseText));
            };
            const ajaxError = (e) => {
                utility.showNotificationPopup({
                    title: "Error", content: `<p class='text-center'>${e.target.responseText}</p>`, hideCloseIcon: true,
                    button: {
                        text: "OK",
                        url: "/account/checkout/"
                    }
                });
                this.enableSubmitButtons();
                this.enablePaymentMethods();
                utility.removeClass(this.activePaymentMethod, "disabled")
                utility.removeFormInputErrors(this.checkoutForm);
            };
            const ajaxAlways = () => {
                this.enableSubmitButtons();
            };
            const ajaxOptions = {
                url: "/api/web/checkout/perform-checkout",
                method: "POST",
                data: formData,
                success: ajaxSuccess,
                always: ajaxAlways,
                error: ajaxError
            };

            this.disableSubmitButtons();
            utility.addClass(this.activePaymentMethod, "disabled");
            utility.ajaxRequest(ajaxOptions);
        }

        handlePayPal(action) {
            let savePayPal = this.savePayPal;
            const paymentAmount = this.checkoutForm.querySelector("input[name='PaymentAmount']").value;
            const customerPaymentMethodId = this.checkoutForm.querySelector("input[name=CustomerPaymentMethodId]").value;
            let getClientTokenApi;
            let payPalLoading = document.getElementById("paypal-button");

            //change api call for hostedfield 
            if (action && action == 'hosted') {
                getClientTokenApi = `/api/web/account/payment-methods/braintree/get-client-token?paymentmethodid=1001&save=${savePayPal}`;
            }
            else if (action && (action == 'hosted-checkout')) {
                getClientTokenApi = `/api/web/account/payment-methods/braintree/cc/saved/get-client-data?customerPaymentMethodId=${customerPaymentMethodId}&amount=${paymentAmount}`;
                utility.showNotificationPopup({
                    title: "Processing Credit Card",
                    centreContent: true,
                    hideCloseIcon: true,
                    content: `Please wait...`
                });
            }
            else {
                getClientTokenApi = `/api/web/account/payment-methods/braintree/get-transaction-client?paymentmethodid=4001&save=${savePayPal}`;
                if (payPalLoading) {
                    payPalLoading.innerHTML = `<p class='text-center'>Loading PayPal...</p>`;
                }
            }

            // Loading state while creating paypal buttons
            if (action == 'paypal') {
                this.checkoutForm.querySelector("input[name=PaymentMethodId]").value = 4001;
                this.checkoutForm.querySelector("input[name=SavePayPal]").value = savePayPal;
            }
 

            let that = this;
            fetch(getClientTokenApi, { method: 'GET' })
                .then(response => response.json())
                .then(response => {
                    if (response.Success) {
                        braintree.client.create({
                            authorization: response.ClientToken
                        }, function (clientErr, clientInstance) {
                            if (clientErr) {
                                let error = `There was an error when trying to add a new card.<br/>Please try again.`;                                
                                utility.logError(`Checkout Page getClientTokenApi Action - ${action} : Error creating client`, clientErr, function () {
                                    that.handlePayPalError(error);
                                });
                                return;
                            }

                            // Data Collector
                            braintree.dataCollector.create({
                                client: clientInstance,
                                clientMetadataId: response.ClientMetaDataId
                            }, function (err, dataCollectorInstance) {
                                let deviceData = "";
                                if (err) {
                                    utility.logError(`Checkout Page getClientTokenApi Action - ${action}: DataCollector Error`, err, null);
                                    // Handle data collector error for PayPal only.   Credit card can continue.
                                    if (!action || action != 'hosted' && action != 'hosted-checkout') {
                                        let error = `There was an error. Please turn off any adblockers or VPNs and try again.`;
                                        that.handlePayPalError(error);
                                        return;
                                    }
                                } else {
                                    deviceData = dataCollectorInstance.deviceData;
                                }
                                
                                beginPayPalCheckout(deviceData, response.ClientMetaDataId)
                            });

                            function beginPayPalCheckout(deviceData, clientMetaDataId) {
                                const paymentAmount = that.checkoutForm.querySelector("input[name='PaymentAmount']").value;

                                // Create PayPal Buttons
                                if (action == 'paypal') {
                                    const btnStyle = {
                                        layout: 'vertical',
                                        color: savePayPal ? 'blue' : 'gold',
                                        shape: 'pill',
                                        label: savePayPal ? 'paypal' : 'checkout', //paypal, checkout, buynow, pay
                                        disableMaxWidth: true,
                                        height: 40
                                    };
                                    const paypalSdkConfig = {
                                        vault: savePayPal ? true : false,
                                        currency: 'AUD',
                                        intent: 'capture'
                                    };
                                    const paypalPaymentConfig = {
                                        flow: 'checkout', // Required
                                        intent: 'capture',
                                        amount: paymentAmount,
                                        currency: 'AUD',
                                        requestBillingAgreement: savePayPal ? true : false,
                                        riskCorrelationId: clientMetaDataId
                                    };
            
                                    // Create a PayPal Checkout Component.
                                    braintree.paypalCheckout.create({
                                        client: clientInstance
                                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                                        if (paypalCheckoutErr) {
                                            let error = `There was an error creating PayPal Checkout.`;
                                            utility.logError("paypalCheckoutErr", paypalCheckoutErr, function () {
                                                that.handlePayPalError(error);
                                            });
                                            if (payPalLoading) {
                                                payPalLoading.innerHTML = 'Error creating PayPal Checkout';
                                            }
                                            return;
                                        }
                                        // Load the PayPal JS SDK (see Load the PayPal JS SDK section)
                                        paypalCheckoutInstance.loadPayPalSDK(
                                            paypalSdkConfig
                                            , function () {
                                                const paypal = window.paypal;
                                                payPalLoading.innerHTML = '';

                                                paypal &&
                                                    paypal.Buttons({
                                                        fundingSource: paypal.FUNDING.PAYPAL,
                                                        style: btnStyle,
                                                        //createBillingAgreement: function () {
                                                        //    return paypalCheckoutInstance.createPayment(paypalPaymentConfig);
                                                        //},
                                                        createOrder: function () {
                                                            return paypalCheckoutInstance.createPayment(
                                                                paypalPaymentConfig
                                                            );
                                                        },
                                                        onApprove: function (data, actions) {
                                                            utility.addClass(that.activePaymentMethod, "disabled");            
                                                            that.disablePaymentMethods();
                                                            return paypalCheckoutInstance.tokenizePayment(data, function (err, payload) {                                                                
                                                                that.performPayPalCheckout(deviceData, payload.nonce)                       
                                                            });
                                                        },

                                                        onCancel: function (data) {
                                                            utility.removeClass(that.activePaymentMethod, "disabled");
                                                            that.enablePaymentMethods();
                                                            that.enableSubmitButtons();
                                                        },

                                                        onError: function (err) {
                                                            utility.removeClass(that.activePaymentMethod, "disabled");
                                                            that.enablePaymentMethods();

                                                            let error = `Paypal Error. Please contact customer support`;
                                                            utility.logError("paypalCheckoutInstance.loadPayPalSDK Error", err, function () {
                                                                that.handlePayPalError(error);
                                                            });
                                                        }
                                                    }).render('#paypal-button').then(function () {
                                                        const payPalSaveCheck = that.checkoutForm.querySelector("input[name=SavePayPal]");
                                                        if (payPalSaveCheck) {
                                                            payPalSaveCheck.removeAttribute("disabled");
                                                            utility.removeClass(document.getElementById("checkSavePayPal"), "disabled");
                                                        }
                                                    });

                                            });
                                    });
                                }

                                // Tokenized Paypal button Checkout
                                if (action == 'paypal-checkout') {
                                    that.performPayPalCheckout(deviceData)                        
                                }

                                // Tokenized Hosted Checkout
                                if (action == 'hosted-checkout') {
                                    let authRequired = response.AuthRequired;
                                    let threeDSAvailable = response.ThreeDSAvailable;
                                    let threeDSAuthData = response.ThreeDSAuthData;

                                    // If AuthRequired is false, not mastercard - continue normal checkout
                                    if (!authRequired) {
                                        that.performPayPalCheckout(deviceData)
                                    }
                                    // check if auth required is true and threeDSAvailable is true
                                    else if (threeDSAvailable && deviceData) {
                                        braintree.threeDSecure.create({
                                            authorization: response.ClientToken,
                                            version: '2'
                                        }, function (threeDSecureErr, threeDSecure) {
                                            if (threeDSecureErr) {
                                                utility.logError("Checkout Page threeDSecure.create threeDSecureErr", threeDSecureErr, null);
                                                that.createCVVOnlyHostedFields(deviceData, clientInstance);
                                                return;
                                            }
                                            threeDSecure.on('lookup-complete', function (data, next) {
                                                utility.hidePopups();
                                                //// check if challenge is presented, skip and ask for cvv instead else continue
                                                //console.log(data)
                                                //if (data.paymentMethod.threeDSecureInfo.status) {
                                                //    console.info("threeDSecureInfo Status: ", data.paymentMethod.threeDSecureInfo.status);
                                                //}
                                                //if (data.paymentMethod.threeDSecureInfo.status && data.paymentMethod.threeDSecureInfo.status == "challenge_required") {
                                                //    console.log("3DS Challenge - call CVV Popup Instead");

                                                //    that.createCVVOnlyHostedFields(deviceData, clientInstance);

                                                //    fetch(`/api/web/account/payment-methods/braintree/cc/saved/validate-threeds?customerPaymentMethodId=${customerPaymentMethodId}&nonce=${data.paymentMethod.nonce}`, { method: 'GET' })
                                                //        .catch(e => console.log("validate threeDSecure error on challenge:", e));
                                                //    return
                                                //}
                                                next();
                                            });
                                            threeDSecure.verifyCard(threeDSAuthData, function (err, response) {
                                                // Handle response
                                                if (err) {                                                    
                                                    console.log("Cardinal SDK Error (checkout) - cvv challenge")
                                                    utility.logError("Checkout Page threeDSecure.verifycard err", err, null);
                                                    that.createCVVOnlyHostedFields(deviceData, clientInstance); 
                                                    return
                                                }
                                                let threedsNonce = response.nonce;
                                                let cardinalData = JSON.stringify(response.rawCardinalSDKVerificationData);
                                                let validateThreedsApi = `/api/web/account/payment-methods/braintree/cc/saved/validate-threeds?customerPaymentMethodId=${customerPaymentMethodId}&nonce=${threedsNonce}&cardinalData=${cardinalData}`;

                                                fetch(validateThreedsApi, { method: 'GET' })
                                                    .then(response => response.json())
                                                    .then(response => {                                                
 
                                                        // V Valid 3DSecure authentication successful.  Pass the returned nonce with device data to deposit method to continue.
                                                        // I Invalid 3DSecure authentication was rejected.  Do not continue with deposit.
                                                        //C User Cancelled

                                                        if (response.ResultCode == 'V') {
                                                            that.performPayPalCheckout(deviceData, threedsNonce)
                                                        }
                                                        else if (response.ResultCode == 'I') {
                                                            // Show not successful UI popup
                                                            that.createCVVOnlyHostedFields(deviceData, clientInstance);
                                                        }
                                                        else if (response.ResultCode == 'C') {
                                                            // Dont Do anything
                                                        }
                                                        else {
                                                            //catch all
                                                            that.handlePayPalError()
                                                        }
                                                    }).catch((error) => {
                                                        utility.showNotificationPopup({
                                                            title: "Error Processing Card", content: `<p class='text-center'>Something went wrong, please try again.</p>`, hideCloseIcon: true,
                                                            centreContent: true,
                                                            button: {
                                                                text: "OK",
                                                                url: "/account/checkout/"
                                                            }
                                                        });
                                                 });
                                            });
                                        });
                                    }
                                    // if auth req = true and ThreeDSavailable = false -> ask for cvv
                                    else {
                                        that.createCVVOnlyHostedFields(deviceData, clientInstance);
                                    }
                                }
                                // New Credit Card
                                if (action == 'hosted') {
                                    that.createHostedFields(deviceData, clientInstance);
                                }
                            }
                        });
                    } else {
                        utility.logError("Checkout: Fetch getClientTokenApi failed", response.Message, function () {
                            utility.showNotificationPopup({
                                title: "Error", content: `<p class='text-center'>${response.Message}</p>`, hideCloseIcon: true,
                                centreContent: true,
                                button: {
                                    text: "OK",
                                    url: "/account/checkout/"
                                }
                            });
                        });
                    }
                }).catch((error) => {
                    //Unauthorized 
                    utility.showLoginPopup();
                });
        }

    },

    checkoutExpandClick: function () {
        [...document.querySelectorAll("#checkout--checkout-form .payment-expand")].map(el => {
            const details = el.nextElementSibling;
            if (details && details.classList.contains("payment-content")) {
                el.onclick = () => {
                    [...document.querySelectorAll("#checkout--checkout-form .payment-expand")].map(el => {
                        utility.removeClass(el, "active");
                        if (el.nextElementSibling) {
                            el.nextElementSibling.style.maxHeight = 0;
                        }
                    });
                    utility.toggleClass(el, "active");
                    if (el.classList.contains('active')) {
                        details.style.maxHeight = `${details.scrollHeight}px`;
                    }
                    else {
                        details.style.maxHeight = 0;
                    }
                };
            }
        });
    },
}

export default checkout;


// WEBPACK FOOTER //
// ./assets/src/js/classes/checkout.js